module.exports = __webpack_public_path__ + "static/media/iphone6-2up-blank.c6563d5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphone/iphone6/iphone6-2up-blank.svg
// module id = 31
// module chunks = 0